var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableListIcon = function SvgTableListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.783 4.528H5.71a1 1 0 0 0-1 1V17.36a1 1 0 0 0 1 1h10.074a1 1 0 0 0 1-1V5.528a1 1 0 0 0-1-1m-10.074-1a2 2 0 0 0-2 2V17.36a2 2 0 0 0 2 2h10.074a2 2 0 0 0 2-2V5.528a2 2 0 0 0-2-2zm2.398 6.537a.5.5 0 0 1 .5-.5h6.037a.5.5 0 0 1 0 1H8.607a.5.5 0 0 1-.5-.5m.5-3.139a.5.5 0 0 0 0 1h6.037a.5.5 0 0 0 0-1zm-.5 5.778a.5.5 0 0 1 .5-.5h6.037a.5.5 0 1 1 0 1H8.607a.5.5 0 0 1-.5-.5m.5 2.139a.5.5 0 0 0 0 1h6.037a.5.5 0 1 0 0-1zm-1.38-4.718a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m-.44-2.199a.44.44 0 1 0 0-.88.44.44 0 0 0 0 .88m.44 4.838a.44.44 0 1 1-.88 0 .44.44 0 0 1 .88 0m-.44 3.079a.44.44 0 1 0 0-.88.44.44 0 0 0 0 .88",
    clipRule: "evenodd"
  })));
};
export default SvgTableListIcon;